import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

import useCurrentOrganization from 'hooks/useCurrentOrganization';
import useGlobalStore from 'hooks/useGlobalStore';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props, RedirectLoginOptions } from './types';

const LoginPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { loginWithRedirect, user } = useAuth0();
    const { currentOrganization } = useCurrentOrganization();
    const { setValue: setCurrentOrganizationValue } = useGlobalStore({
        namespace: 'useCurrentOrganization'
    });
    const { setValue: setCurrentUserValue } = useGlobalStore({ namespace: 'useCurrentUser' });
    const [searchParams] = useSearchParams();
    const organizationId = searchParams.get('organization');
    const invitation = searchParams.get('invitation');

    useEffect(() => {
        if (user) {
            setCurrentUserValue({ currentUser: null });
        }

        if (typeof currentOrganization !== 'undefined') {
            setCurrentOrganizationValue({ currentOrganization: null });
        }

        const loginOptions: RedirectLoginOptions | undefined =
            organizationId && invitation
                ? {
                      authorizationParams: {
                          invitation,
                          organization: organizationId
                      }
                  }
                : undefined;

        loginWithRedirect(loginOptions);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invitation, loginWithRedirect, organizationId]);

    return <p data-testid={testId}>Login - Loading...</p>;
};

export default LoginPage;
